export default {
      id: "i-arrow-usage",
      viewBox: "0 0 14 9",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow",
      toString: function () {
        return this.url;
      }
    }